/**
 * @description: This class registers an event handler to the input type file element if present in the skin. Upon user selecting
 * a file, event handler will create an XHR POST request to send multipart request body to the file transfer server.
 * @module: com.inq.flash.client.control
 * @class: UploadHandler
 */
com.inq.flash.client.control.UploadHandler = {};

/**
 * @description: init function will register change event handler if uploadButton is found in the mxml
 * @static
 * @public
 */
com.inq.flash.client.control.UploadHandler.init = function() {
	com.inq.utils.Util.publish(
		"window.inqFrame.com.inq.flash.client.control.UploadHandler.engageFileUpload",
		com.inq.flash.client.control.UploadHandler.engageFileUpload
	);
	/** @type {Application} */
	var application = Application.application;
	/** @type {com.inq.ui.FileInput} */
	var uploadButton = application.getMxmlItem("UploadButton");
	/** @type {com.inq.ui.Button} */
	var closeButton = application.getButton("UploadCloseButton");
	if (uploadButton && uploadButton.input) {
		com.inq.flash.client.control.UploadHandler.fileInput = uploadButton.input;
		com.inq.flash.client.control.UploadHandler.fileInput.addEventListener(
			"change",
			com.inq.flash.client.control.UploadHandler.actionUpload
		);
		com.inq.flash.client.control.UploadHandler.closeButton = application.getButton("UploadCloseButton");
		if (closeButton) {
			com.inq.flash.client.control.UploadHandler.closeButton = closeButton._img;
			com.inq.flash.client.control.UploadHandler.closeButton.addEventListener(
				"click",
				com.inq.flash.client.control.UploadHandler.actionClose
			);
		}
		com.inq.flash.client.control.UploadHandler.successText = application.getMxmlItem("UploadSuccess");
		com.inq.flash.client.control.UploadHandler.errorTextItem = application.getMxmlItem("UploadError");
	}
};

/**
 * @description close function to clear all event listener
 */
com.inq.flash.client.control.UploadHandler.close = function() {
	if (com.inq.flash.client.control.UploadHandler.fileInput) {
		com.inq.flash.client.control.UploadHandler.fileInput.removeEventListener(
			"change",
			com.inq.flash.client.control.UploadHandler.actionUpload
		);
	}
	com.inq.flash.client.control.UploadHandler.fileInput = null;
	if (com.inq.flash.client.control.UploadHandler.closeButton) {
		com.inq.flash.client.control.UploadHandler.closeButton.removeEventListener(
			"click",
			com.inq.flash.client.control.UploadHandler.actionClose
		);
	}
	com.inq.flash.client.control.UploadHandler.closeButton = null;

	com.inq.flash.client.control.UploadHandler.resetAlerts();
	com.inq.flash.client.control.UploadHandler.errorTextItem = null;
	com.inq.flash.client.control.UploadHandler.successText = null;

	com.inq.flash.client.control.UploadHandler.uploadForm = null;
};

/**
 * @description: event handler to send multipart request body to the file transfer server
 * @static
 * @public
 * @param e {Event}
 */
com.inq.flash.client.control.UploadHandler.actionUpload = function(e) {
	/**
	 * converting MB to bytes
	 * @type {number}
	 */
	var fileSize = parseInt(com.inq.flash.client.control.FlashPeer.getFileTransferSize() || "5") * 1000 * 1000;
	/** @type {String} **/
	var agentGroupId = com.inq.flash.client.control.FlashVars.getValue("agID");
	/** @type {String} **/
	var url = com.inq.flash.client.control.FlashPeer.getFileTransferUrl() + "/filetransfer/rest/cont/uploadFile";
	/** @type {String} **/
	var siteId = com.inq.flash.client.control.FlashVars.getValue("siteID");
	/** @type {com.inq.ui.Text} **/
	var eCb = com.inq.flash.client.control.UploadHandler.engageParms["cb"];

	com.inq.flash.client.control.UploadHandler.resetAlerts();

	if (e.target.files) {
		/** @type {XMLHttpRequest} **/
		var xhr;
		/** @type {FormData} **/
		var formData = new FormData();
		/** @type {File} **/
		var file = e.target.files[0];
		/** @type {String} **/
		var fileName = file.name;
		var hasFileExtension = com.inq.flash.client.control.UploadHandler.fileExtensionAllowed(fileName);
		if (!hasFileExtension) {
			com.inq.flash.client.control.UploadHandler.showUploadFailedMessage(
				com.inq.flash.client.control.UploadHandler.engageParms["typeError"] ||
					com.inq.utils.Util.getConfig(
						"uploadTypeError",
						"File type not allowed to upload:" + fileName
					)
			);
			eCb && eCb("typeError");
			return "typeError";
		}
		if (file.size > fileSize) {
			com.inq.flash.client.control.UploadHandler.showUploadFailedMessage(
				com.inq.flash.client.control.UploadHandler.engageParms["sizeError"] ||
					com.inq.utils.Util.getConfig(
						"uploadSizeError",
						"File is too large. Please select a file that is less than " + (fileSize / 1000000) + " MB")
			);
			eCb && eCb("sizeError");
			return "sizeError";
		}

		formData.append('file',e.target.files[0]);
		formData.append('siteId',siteId);
		xhr = new XMLHttpRequest();
		xhr.open("POST",url);
		xhr.send(formData);
		xhr.onreadystatechange = function() {
			if (xhr.status === 200 && xhr.readyState === XMLHttpRequest.DONE) {
				/** @type {{fileName: string, responseStatus: number}} */
				var resp = JSON.parse(xhr.response);
				if (resp && resp["responseStatus"] === 200) {
					com.inq.flash.client.control.UploadHandler.sendUploadSuccessMessage(resp, siteId, agentGroupId);
					eCb && eCb("success");
				}
			} else if (xhr.status === 400 && xhr.readyState === XMLHttpRequest.DONE) {
				com.inq.flash.client.control.UploadHandler.showUploadFailedMessage(
					com.inq.flash.client.control.UploadHandler.engageParms["badFile"] ||
						com.inq.utils.Util.getConfig("badFile", "Uploaded file contains virus"));
				eCb && eCb("badFile");
			} else if (xhr.readyState === XMLHttpRequest.DONE) {
				com.inq.flash.client.control.UploadHandler.showUploadFailedMessage(
					com.inq.flash.client.control.UploadHandler.engageParms["serverError"] ||
						com.inq.utils.Util.getConfig(
							"uploadServerError",
							"Server Encountered Unexpected Error"
						)
				);
				eCb && eCb("serverError");
			}
		};
	} else {
		return com.inq.flash.client.control.UploadHandler.actionUploadIE(e, agentGroupId, siteId);
	}
};

/**
 * actionUploadIEEvent - is used to send selected file to file transfer server for IE browser.
 *
 * @param {Event} e
 * @param {string} agentGroupId
 * @param {string} siteId
 * @return {string|undefined}
 */
com.inq.flash.client.control.UploadHandler.actionUploadIE = function (e, agentGroupId, siteId) {
	/** @type {String} **/
	var fileName;
	/** @type {HTMLInputElement} **/
	var siteIdInput;
	/** @type {HTMLIFrameElement} **/
	var iframe;
	/** @type {Window} */
	var windowElement = com.inq.ui.SkinLoader.skinInClient ? window.top : window;
	var eCb = com.inq.flash.client.control.UploadHandler.engageParms["cb"];
	/** @type {String} **/
	var url = com.inq.flash.client.control.FlashPeer.getFileTransferUrl() + "/filetransfer/rest/cont/uploadFileIE";
	if(e.srcElement) {
		fileName = e.srcElement.value;
		var hasFileExtension = com.inq.flash.client.control.UploadHandler.fileExtensionAllowed(fileName);
		if (!hasFileExtension) {
			com.inq.flash.client.control.UploadHandler.showUploadFailedMessage(
				com.inq.flash.client.control.UploadHandler.engageParms["typeError"] ||
					com.inq.utils.Util.getConfig(
						"uploadTypeError",
						"File type not allowed to upload:" + fileName
					)
			);
			eCb && eCb("typeError");
			return "typeError";
		}
		if (!com.inq.flash.client.control.UploadHandler.uploadForm) {
			com.inq.flash.client.control.UploadHandler.uploadForm = document.createElement('form');
			siteIdInput = document.createElement("input");
			siteIdInput.setAttribute("name","siteId");
			siteIdInput.setAttribute("type","text");
			siteIdInput.value = siteId;

			com.inq.flash.client.control.UploadHandler.uploadForm.setAttribute("action", url);
			com.inq.flash.client.control.UploadHandler.uploadForm.setAttribute("method", "post");
			com.inq.flash.client.control.UploadHandler.uploadForm.setAttribute("enctype", "multipart/form-data");
			com.inq.flash.client.control.UploadHandler.uploadForm.setAttribute("encoding", "multipart/form-data");
			com.inq.flash.client.control.UploadHandler.uploadForm.setAttribute("id","IEfileUploadForm");

			if (com.inq.flash.client.control.UploadHandler.fileInput) {
				com.inq.flash.client.control.UploadHandler.uploadForm.appendChild(
					com.inq.flash.client.control.UploadHandler.fileInput
				);
				com.inq.flash.client.control.UploadHandler.fileInput.parentElement.appendChild(
					com.inq.flash.client.control.UploadHandler.uploadForm
				);
			} else {
				windowElement.document.body.appendChild(com.inq.flash.client.control.UploadHandler.uploadForm);
				com.inq.flash.client.control.UploadHandler.uploadForm.appendChild(e.target);
			}
			com.inq.flash.client.control.UploadHandler.uploadForm.appendChild(siteIdInput);

			iframe = document.createElement("iframe");
			iframe.setAttribute("id", "upload_iframe");
			iframe.setAttribute("name", "upload_iframe");
			iframe.setAttribute("style", "border: none;display: none;");
			com.inq.flash.client.control.UploadHandler.uploadForm.appendChild(iframe);
			windowElement.frames["upload_iframe"].name = "upload_iframe";

			onmessage = function(e){
				if(url.indexOf(e.origin)!=-1) {
					var data = JSON.parse(e.data);
					if (data && data["responseStatus"] == "200") {
						com.inq.flash.client.control.UploadHandler.sendUploadSuccessMessage(data, siteId, agentGroupId);
						eCb && eCb("success");
					} else if (data && data["responseStatus"] == "400") {
						com.inq.flash.client.control.UploadHandler.showUploadFailedMessage(
							com.inq.flash.client.control.UploadHandler.engageParms["badFile"] ||
								com.inq.utils.Util.getConfig("badFile", "Uploaded file contains virus")
						);
						eCb && eCb("badFile");
					} else {
						com.inq.flash.client.control.UploadHandler.showUploadFailedMessage(
							com.inq.flash.client.control.UploadHandler.engageParms["serverError"] ||
								com.inq.utils.Util.getConfig(
									"uploadServerError",
									"Server Encountered Unexpected Error"
								)
						);
						eCb && eCb("serverError");
					}
				}
			};
			com.inq.flash.client.control.UploadHandler.uploadForm.setAttribute("target", "upload_iframe");
		}
		com.inq.flash.client.control.UploadHandler.uploadForm.submit();
	}
};

com.inq.flash.client.control.UploadHandler.engageFileUpload = function (e, params) {
	com.inq.flash.client.control.UploadHandler.engageParms = params;
	return com.inq.flash.client.control.UploadHandler.actionUpload(e);
};

/**
 * actionClose - is a handler of the click event for close button of the upload panel
 */
com.inq.flash.client.control.UploadHandler.actionClose = function () {
	com.inq.flash.client.chatskins.SkinControl.getApplicationController()
		.sendSystemMessage("Customer has closed the file upload window.");
	com.inq.flash.client.control.UploadHandler.resetAlerts();
};

/**
 * Resets alerts of the "uploadHandler" to default state
 */
com.inq.flash.client.control.UploadHandler.resetAlerts = function () {
	if (com.inq.flash.client.control.UploadHandler.errorTextItem) {
		com.inq.flash.client.control.UploadHandler.errorTextItem.setText("");
		com.inq.flash.client.control.UploadHandler.errorTextItem.setVisible(false);
	}
	if (com.inq.flash.client.control.UploadHandler.successText) {
		com.inq.flash.client.control.UploadHandler.successText.setText("");
		com.inq.flash.client.control.UploadHandler.successText.setVisible(false);
	}
};

/**
 * Displays element with the text about the successful download and sends this text to the server.
 * Also it is used to send file url to agent.
 *
 * @param {{fileName: string, responseStatus: number}} resp
 * @param {string} siteId
 * @param {string} agentGroupId
 */
com.inq.flash.client.control.UploadHandler.sendUploadSuccessMessage = function (resp, siteId, agentGroupId) {
	/** @type {string} */
	var fileDel = com.inq.flash.client.control.FlashPeer.getFileDeleteSetting() || "ON_CHAT_END";
	/** @type {string} */
	var uploadMsg = com.inq.flash.client.control.UploadHandler.engageParms["success"] ||
		com.inq.utils.Util.getConfig("uploadSuccessMsg", "File successfully uploaded");
	com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendSystemMessage(uploadMsg);
	com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendFileUploadMessage(
		com.inq.flash.client.control.FlashPeer.getFileTransferApiUrl() +
			"/chatfiles/" + siteId + "/" + encodeURI(resp["fileName"]) + "?site=" + siteId + "&agentGroup=" + agentGroupId,
		fileDel
	);
	if (com.inq.flash.client.control.UploadHandler.successText) {
		com.inq.flash.client.control.UploadHandler.successText.setText(uploadMsg);
		com.inq.flash.client.control.UploadHandler.successText.setVisible(true);
	}
	/*to check that "fileInput" should not empty. It can happen when we use ACIF survey with this functionality to upload something */
	if (com.inq.flash.client.control.UploadHandler.fileInput) {
		com.inq.flash.client.control.UploadHandler.fileInput.value = "";
	}
};

/**
 * Displays element with text about error loading and sends this text to the server.
 *
 * @param {string} msg - error text about loading file.
 */
com.inq.flash.client.control.UploadHandler.showUploadFailedMessage = function (msg) {
	if (com.inq.flash.client.control.UploadHandler.errorTextItem) {
		com.inq.flash.client.control.UploadHandler.errorTextItem.setText(msg);
		com.inq.flash.client.control.UploadHandler.errorTextItem.setVisible(true);
	}
	com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendSystemMessage(msg);
	if (com.inq.flash.client.control.UploadHandler.fileInput) {
		com.inq.flash.client.control.UploadHandler.fileInput.value = "";
	}
};

/**
 * Check for file Extension to be present in db configuration.site.file_transfer_extensions
 * configured via Portal
 * @param {string} fileName
 * @returns {boolean}
 */
com.inq.flash.client.control.UploadHandler.fileExtensionAllowed = function (fileName) {
	/** @type {string} * */
	var fileTransferExtensions = com.inq.flash.client.control.FlashPeer.getfileTransferExtensions();

	var fileExtension = fileName.split(".").reverse()[0];

	var fileNameExtensionList = [];

	if (typeof fileTransferExtensions === "string") {
		fileNameExtensionList = fileTransferExtensions.split(",");
	}

	return fileNameExtensionList.indexOf(fileExtension) !== -1;
};

/** @type {?HTMLFormElement} */
com.inq.flash.client.control.UploadHandler.uploadForm = null;
/** @type {?HTMLInputElement} */
com.inq.flash.client.control.UploadHandler.fileInput = null;
/** @type {?com.inq.ui.Button} */
com.inq.flash.client.control.UploadHandler.closeButton = null;
/** @type {?com.inq.ui.Text} */
com.inq.flash.client.control.UploadHandler.successText = null;
/** @type {?com.inq.ui.Text} */
com.inq.flash.client.control.UploadHandler.errorTextItem = null;

com.inq.flash.client.control.UploadHandler.engageParms = {};
